import {
  AUTHOR_CHANGED,
  CATEGORY_CHANGED,
  CLEAR_FILTER,
  SEARCH_NAME
} from "./actionTypes";
import initialState from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTHOR_CHANGED:
      const { authorName, authorChangeType } = action.payload;
      switch (authorChangeType) {
        case "added":
          return {
            ...state,
            authorNames: [...state?.authorNames, authorName],
          };

        case "removed":
          return {
            ...state,
            authorNames: state?.authorNames.filter(
              (existingAuthorName) => existingAuthorName !== authorName
            ),
          };

        default:
          return state;
      }

    case CATEGORY_CHANGED:
      const { categoryName, categoryChangeType } = action.payload;
      switch (categoryChangeType) {
        case "added":
          return {
            ...state,
            blogCategories: [...state?.blogCategories, categoryName],
          };
        case "removed":
          return {
            ...state,
            blogCategories: state?.blogCategories.filter(
              (existingCategoryName) => existingCategoryName !== categoryName
            ),
          };
        default:
          return state;
      }

    case SEARCH_NAME: {
      return {
        ...state,
        search: action?.payload,
      };
    }
    case CLEAR_FILTER: {
      return {
        ...state,
        authorNames: [],
        blogCategories: [],
      };
    }
    default:
      return state;
  }
};

export default reducer;
